module.exports = __webpack_public_path__ + "static/media/service-img-18.eaa1804a.jpg";